<template lang="html">
<div class="analytics analytics-transactions">
  <row>
    <el-tabs v-model="tab" type="border-card" @tab-click="tabClick">
      <!-- General status start -->
      <el-tab-pane :label="$t('Views.Analytics.Transaction.generalStatus')" name="first">
        <row>
          <div class="sl-col-4">
              <div class="sl-body">
                <p class="sl-name">{{$t('Chart.trxAmount')}} ({{$store.state.theme.companyInfo.currency}})</p>
                <p class="text-center">
                  <el-radio-group v-model="first.statusRadio">
                    <el-radio-button label="op1" @click.native="resetStatusOp('week','Recent 7 days')" :option="first.statusOption.week">{{$tc('Date.dateRange',0)}}</el-radio-button>
                    <el-radio-button label="op2" @click.native="resetStatusOp('month','Recent 30 days')" :option="first.statusOption.month">{{$tc('Date.dateRange',1)}}</el-radio-button>
                    <el-radio-button label="op3" @click.native="resetStatusOp('year','Recent 12 months')" :option="first.statusOption.year">{{$tc('Date.dateRange',2)}}</el-radio-button>
                  </el-radio-group>
                </p>
                <chart :options="first.statusOption.default" ref="status" auto-resize theme="default"></chart>
              </div>
          </div>
        </row>
      </el-tab-pane>
      <!-- General status end -->
      <!-- By Channel start -->
      <el-tab-pane :label="$t('Views.Analytics.Transaction.byChannel')" name="second">
        <!-- transactions by outlet start  -->
        <row>
          <div class="sl-col-4">
            <div class="sl-body">
              <p class="sl-name">{{$t('Chart.transactionByChannel')}} ({{$store.state.theme.companyInfo.currency}})</p>
              <p class="text-center">
                <el-radio-group v-model="second.channelRadio">
                  <el-radio-button label="op1" @click.native="resetChannelOp('week','Recent 7 days')" :option="second.channelOption.week">{{$tc('Date.dateRange',0)}}</el-radio-button>
                  <el-radio-button label="op2" @click.native="resetChannelOp('month','Recent 30 days')" :option="second.channelOption.month">{{$tc('Date.dateRange',1)}}</el-radio-button>
                  <el-radio-button label="op3" @click.native="resetChannelOp('year','Recent 12 months')" :option="second.channelOption.year">{{$tc('Date.dateRange',2)}}</el-radio-button>
                </el-radio-group>
              </p>
              <chart :options="second.channelOption.default" ref="byChannel" auto-resize theme="default" class="sl-any-bar"></chart>
            </div>
          </div>
        </row>
        <!-- transactions by outlet end  -->
      </el-tab-pane>
      <!-- By Channel end -->
      <!-- tab percentage start -->
      <el-tab-pane :label="$t('Views.Analytics.Transaction.percentage')" name="third">
        <row>
          <div class="sl-col-2">
            <div class="sl-body">
              <p class="sl-name">{{$t('Chart.channelPercentage')}}</p>
              <chart :options="third.channelOption" ref="percentageChannel" auto-resize theme="default"></chart>
            </div>
          </div>
          <div class="sl-col-2">
            <div class="sl-body">
              <p class="sl-name">{{$t('Chart.statusPercentage')}}</p>
              <chart :options="third.statusOption" ref="percentageStatus" auto-resize theme="default"></chart>
            </div>
          </div>
        </row>
        <!-- outlet percentage start  -->
        <!-- <row>
          <div class="sl-col-2">
            <div class="sl-body">
              <p class="sl-name">{{$t('Chart.outletPercentage')}}</p>
              <chart :options="third.outletOption" ref="percentageOutlet" auto-resize theme="default"></chart>
            </div>
          </div>
        </row> -->
        <!-- outlet percentage end  -->
      </el-tab-pane>
    </el-tabs>
  </row>
</div>
</template>

<script>
import api from '../../api'
import * as config from '../../util/echart-config'
export default {
  name: 'analytics-transactions',
  data() {
    return {
      tab: 'first',
      first: {
        box: [],
        statusOption: {
          default: config.line,
          week: {},
          month: {},
          year: {}
        },
        statusRadio: 'op1'
      },
      second: {
        channelOption: {
          default: null,
          week: {},
          month: {},
          year: {}
        },
        channelRadio: 'op1'
      },
      third: {
        channelOption: null,
        outletOption: null,
        statusOption: null
      }
    }
  },
  methods: {
    tabClick() {
      const vm = this
      if (this.tab === 'second') {
        api.FetchAnalyticsTransactionsTabBChart().then(res => {
          this.second.channelRadio = 'op1'
          const result = res.data.data
          vm.second.channelOption.default = config.getSingleBarOption(result.week, config)
          vm.second.channelOption.week = result.week
          vm.second.channelOption.month = result.month
          vm.second.channelOption.year = result.year
          vm.$nextTick(function () {
            vm.$refs.byChannel.resize()
          })
        })
      } else if (this.tab === 'third') {
        api.FetchAnalyticsTransactionsTabCChart().then(res => {
          const result = res.data.data
          vm.third.channelOption = config.getDoublePieOption(result.channel, config, ['', ''])
          vm.third.outletOption = config.getSinglePieOption(result.outlet, config)
          vm.third.statusOption = config.getSinglePieOption(result.status, config)
          vm.$nextTick(function () {
            vm.$refs.percentageChannel.resize()
            // vm.$refs.percentageOutlet.resize()
            vm.$refs.percentageStatus.resize()
          })
        })
      } else if (this.tab === 'first') {
        this.first.statusRadio = 'op1'
        api.FetchAnalyticsTransactionsTabAChart().then(res => {
          const result = res.data.data
          vm.first.statusOption.week = result.week
          vm.first.statusOption.month = result.month
          vm.first.statusOption.year = result.year
          vm.resetStatusOp('week', 'Recent 7 days')
          vm.$nextTick(vm.$refs.status.resize())
        })
      }
    },
    resetStatusOp(params, name) {
      this.$refs.status.mergeOptions({
        tooltip: {
          formatter: '{b}<br/>Per Channel : ' + this.$store.state.theme.companyInfo.currency + '{c}'
        },
        xAxis: [
          {
            data: this.first.statusOption[params].xAxis
          }
        ],
        yAxis: [
          {
            min: Math.min(...this.first.statusOption[params].yAxis)
          }
        ],
        series: [{
          data: this.first.statusOption[params].yAxis
        }]
      })
    },
    resetChannelOp(params, name) {
      this.$refs.byChannel.mergeOptions({
        legend: {
          data: this.second.channelOption[params].yAxis.map((item) => (item.name))
        },
        xAxis: [
          {
            data: this.second.channelOption[params].xAxis
          }
        ],
        series: convertData(this.second.channelOption[params].yAxis)
      })
    }
  },
  created() {
    const vm = this
    // api.FetchAnalyticsTransactionsTabABox().then(res => {
    //   vm.first.box = res.data.data
    // })
    api.FetchAnalyticsTransactionsTabAChart().then(res => {
      const result = res.data.data
      vm.first.statusOption.week = result.week
      vm.first.statusOption.month = result.month
      vm.first.statusOption.year = result.year
      vm.resetStatusOp('week', 'Recent 7 days')
    })
  }
}

function convertData(yAxis) {
  return yAxis.map((item) => ({
    name: item.name,
    stack: item.stack,
    data: item.value,
    type: 'bar'
  }))
}
</script>

<style>
.sl-body .sl-any-bar canvas {
  top: 0px !important;
}
</style>



// WEBPACK FOOTER //
// transactions.vue?748737fb